module.exports = __webpack_public_path__ + "static/media/bsv.2b3f64aa.png";